import { CELL_FILTER, IXVIColumnFilterParams } from '@app/shared/types';
import { I18n } from '../strings-keys';

import { mapTextEnumsValueForFilterOption } from '../utils/filter-translation.utils';
import { translateSelectOptions } from '../utils/translate.utils';

export const getFilterOptionsMapper =
  (mapperOptions?: {
    overrideOptionsMap?: Record<string, string>;
  }): IXVIColumnFilterParams['filterOptionsMapper'] =>
  (filterOptions, options) => {
    return translateSelectOptions(
      mapTextEnumsValueForFilterOption(
        filterOptions,
        mapperOptions?.overrideOptionsMap,
      ),
      options,
    );
  };

export const DefaultFilterOptionsMapper: IXVIColumnFilterParams['filterOptionsMapper'] =
  getFilterOptionsMapper();

export const DateTimeFilterOptionsMapper: IXVIColumnFilterParams['filterOptionsMapper'] =
  getFilterOptionsMapper({
    overrideOptionsMap: {
      equals: I18n.Common.DateTime,
      inRangeDate: I18n.Common.DateTimeRange,
    },
  });

export const FilterOptionsMappers: Record<
  string,
  IXVIColumnFilterParams['filterOptionsMapper']
> = {
  // Map your filter options here
  [CELL_FILTER.date]: DefaultFilterOptionsMapper,
  [CELL_FILTER.dateLocale]: DefaultFilterOptionsMapper,
  [CELL_FILTER.dateTime]: DateTimeFilterOptionsMapper,
  [CELL_FILTER.entity]: DefaultFilterOptionsMapper,
};
